import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Navimumbaiairportcab() {



const cardData =
{
  keyword: 'Navi Mumbai Airport Cab',

  heading: 'Lotus Cab: Navi Mumbai Airport Cab Service',

headingDescription:
    "Lotus Cabs offers reliable and affordable Navi Mumbai Airport Cab services for domestic and international airport transfers, business travel, corporate transportation, hotel transfers, railway station pickups, family travel, sightseeing tours, outstation trips, and one-way or round-trip bookings. We provide a premium fleet of AC Sedan, SUV, Innova Crysta, Ertiga, Kia Carens, Tempo Traveller, Luxury Urbania, and Mini Bus driven by professional and experienced chauffeurs. With 24x7 booking support, real-time flight tracking, transparent pricing, doorstep pickup and drop, well-maintained vehicles, and punctual service, Lotus Cabs ensures a smooth, comfortable, and hassle-free travel experience to and from Navi Mumbai International Airport (NMIA). Whether you're traveling for business or leisure, our airport cab service guarantees timely pickups, professional drivers, and a comfortable journey every time.",

  top: 'Top Places Near Navi Mumbai Airport with Lotus Cab',

 topPlaces: [
    {
        title: "Pune",
        description:
            "Pune is one of the most frequently booked destinations from Navi Mumbai International Airport. Business professionals, students, families, and tourists choose Lotus Cabs for comfortable airport transfers via the Mumbai–Pune Expressway. Our professional chauffeurs, clean vehicles, and reliable door-to-door service ensure a smooth and relaxing journey to any location in Pune."
    },
    {
        title: "Lonavala",
        description:
            "Lonavala is a popular hill station located close to Navi Mumbai, famous for Bhushi Dam, Tiger Point, Karla Caves, Rajmachi Fort, and breathtaking Sahyadri landscapes. Travelers arriving at Navi Mumbai Airport often book Lotus Cabs for direct transfers to enjoy scenic drives, pleasant weather, and memorable weekend holidays."
    },
    {
        title: "Shirdi",
        description:
            "Shirdi is one of India's most sacred pilgrimage destinations, attracting millions of Sai Baba devotees every year. Lotus Cabs provides dependable Navi Mumbai Airport to Shirdi taxi services with comfortable vehicles, experienced chauffeurs, and flexible one-way or round-trip travel for a peaceful pilgrimage experience."
    },
    {
        title: "Nashik",
        description:
            "Nashik is renowned for Trimbakeshwar Jyotirlinga, Panchavati, Ram Kund, Sula Vineyards, and the Kumbh Mela. Whether you are traveling for pilgrimage, business, sightseeing, or wine tourism, Lotus Cabs offers safe, comfortable, and convenient airport transfers from Navi Mumbai Airport directly to Nashik."
    },
    {
        title: "Mahabaleshwar",
        description:
            "Mahabaleshwar is one of Maharashtra's most beautiful hill stations, known for Venna Lake, Arthur's Seat, strawberry farms, waterfalls, and breathtaking viewpoints. Travelers arriving at Navi Mumbai Airport can enjoy a comfortable long-distance journey with Lotus Cabs while experiencing premium comfort and reliable service throughout the trip."
    },
    {
        title: "Goa",
        description:
            "Goa is India's most famous beach destination, offering pristine beaches, Portuguese architecture, vibrant nightlife, churches, forts, and luxury resorts. Lotus Cabs provides comfortable long-distance airport cab services from Navi Mumbai Airport to Goa, making family vacations, honeymoon trips, and group holidays enjoyable and stress-free."
    },
    {
        title: "Alibaug",
        description:
            "Alibaug is a popular coastal getaway known for Alibaug Beach, Kolaba Fort, Kashid Beach, beach resorts, and exciting water sports. Located within convenient driving distance from Navi Mumbai Airport, it is an ideal destination for travelers seeking a peaceful beach vacation with comfortable transportation provided by Lotus Cabs."
    },
    {
        title: "Kolhapur",
        description:
            "Kolhapur is famous for the sacred Mahalaxmi Temple, Panhala Fort, Rankala Lake, and authentic Maharashtrian cuisine. Lotus Cabs offers reliable airport taxi services from Navi Mumbai Airport to Kolhapur, ensuring safe, comfortable, and hassle-free travel for pilgrims, business travelers, and families."
    },
    {
        title: "Aurangabad (Chhatrapati Sambhajinagar)",
        description:
            "Aurangabad is home to UNESCO World Heritage Sites including Ajanta Caves and Ellora Caves, along with Grishneshwar Jyotirlinga, Bibi Ka Maqbara, and Daulatabad Fort. Travelers arriving at Navi Mumbai Airport can rely on Lotus Cabs for convenient long-distance transfers to explore Maharashtra's rich cultural, historical, and spiritual heritage."
    },
    {
        title: "Matheran",
        description:
            "Matheran is Asia's only automobile-free hill station and is famous for its scenic viewpoints, heritage toy train, lush forests, waterfalls, and peaceful atmosphere. Lotus Cabs provides comfortable Navi Mumbai Airport taxi services to Matheran, making it a perfect destination for families, couples, and nature lovers looking for a refreshing escape."
    }
],

  "services": [
    {
      "name": "Navi Mumbai Airport Cab Service",
      "description": "Book Navi Mumbai airport cab service for reliable pickup and drop transfers to Navi Mumbai International Airport or Mumbai Airport terminals T1 and T2. Available 24x7 with flexible scheduling to match flight timings. Professional drivers monitor real-time traffic and flight updates to ensure punctual arrival. AC sedan, Ertiga, Innova Crysta, SUV, and luxury vehicles are available for individual and family travel. Transparent taxi fare structure includes toll charges and parking details. Suitable for corporate travelers, tourists, and family airport transfers."
    },
    {
      "name": "Navi Mumbai Airport Taxi Booking Online",
      "description": "Convenient Navi Mumbai airport taxi booking online with instant confirmation and transparent fare estimate. Customers can choose preferred vehicle category and pickup location within Vashi, Nerul, Airoli, Kharghar, or CBD Belapur. Booking confirmation includes driver details and arrival timing. Ideal for business executives and frequent flyers."
    },
    {
      "name": "24x7 Navi Mumbai Airport Cab",
      "description": "Round-the-clock airport cab availability for early morning departures and late-night arrivals. Professional chauffeurs ensure safe and secure travel even during off-peak hours. Vehicles are well-maintained and air-conditioned for comfort."
    },
    {
      "name": "Navi Mumbai Airport Innova Cab",
      "description": "Premium Innova Crysta airport cab offering spacious seating and superior comfort for families and corporate groups. Ideal for travelers carrying extra luggage."
    },
    {
      "name": "Navi Mumbai Airport Ertiga Cab",
      "description": "Affordable Ertiga airport cab suitable for small families and business travelers seeking economical airport transfers."
    },
    {
      "name": "Navi Mumbai Airport Sedan Taxi",
      "description": "Comfortable sedan taxi option for smooth and economical airport pickup and drop services."
    },
    {
      "name": "Navi Mumbai Airport SUV Cab",
      "description": "SUV cab service offering additional luggage capacity and stable ride for airport transfers."
    },
    {
      "name": "Navi Mumbai Airport Luxury Cab",
      "description": "Luxury airport cab service for premium travelers requiring executive-level comfort and professional service."
    }
  ],

  "tableData": [
    ["Navi Mumbai Airport Cab Service", "Navi Mumbai Airport Taxi Booking Online"],
    ["24x7 Navi Mumbai Airport Cab", "Navi Mumbai Airport Innova Cab"],
    ["Navi Mumbai Airport Ertiga Cab", "Navi Mumbai Airport Sedan Taxi"],
    ["Navi Mumbai Airport SUV Cab", "Navi Mumbai Airport Luxury Cab"]
  ],

  "whychoose": [
    {
      "WhyChooseheading": "24x7 Airport Availability",
      "WhyChoosedescription": "Round-the-clock airport transfers matching early and late flight schedules."
    },
    {
      "WhyChooseheading": "Transparent Taxi Fare",
      "WhyChoosedescription": "Clear pricing including toll and parking charges."
    },
    {
      "WhyChooseheading": "Flight Monitoring Support",
      "WhyChoosedescription": "Real-time flight tracking to avoid delays and waiting charges."
    },
    {
      "WhyChooseheading": "Multiple Vehicle Options",
      "WhyChoosedescription": "Sedan, SUV, Ertiga, Innova, and luxury cab categories available."
    },
    {
      "WhyChooseheading": "Professional Drivers",
      "WhyChoosedescription": "Trained chauffeurs familiar with airport routes and city traffic."
    },
    {
      "WhyChooseheading": "Area-Wide Pickup",
      "WhyChoosedescription": "Pickup available across Vashi, Nerul, Airoli, Kharghar, and Belapur."
    },
    {
      "WhyChooseheading": "Comfortable AC Vehicles",
      "WhyChoosedescription": "Well-maintained vehicles ensure relaxed airport transfers."
    },
    {
      "WhyChooseheading": "Instant Online Booking",
      "WhyChoosedescription": "Quick confirmation and easy booking process."
    }
  ]
}












const faqData = [
  {
    question: 'Does Lotus Cab provide Navi Mumbai airport cab service?',
    answer: 'Yes, Lotus Cab offers reliable Navi Mumbai airport cab service for timely pickup and drop with professional drivers and well-maintained vehicles.',
  },
  {
    question: 'Can I book a cab for Navi Mumbai Airport pickup?',
    answer: 'Yes, Lotus Cab provides airport pickup services with real-time flight tracking to ensure timely arrival even if your flight is delayed.',
  },
  {
    question: 'What are the charges for Navi Mumbai airport cab booking?',
    answer: 'Airport cab charges depend on pickup location, distance, vehicle type, and time of travel. Lotus Cab offers transparent pricing with no hidden charges.',
  },
  {
    question: 'Is Navi Mumbai airport drop service available 24/7?',
    answer: 'Yes, Lotus Cab operates 24/7 airport drop services for early morning and late-night flights from Navi Mumbai.',
  },
  {
    question: 'Which vehicles are available for airport transfer?',
    answer: 'We provide Sedan cars like Dzire and Etios for individuals and SUVs like Ertiga and Innova Crysta for families and group airport transfers.',
  },
  {
    question: 'Do you provide luggage assistance for airport travel?',
    answer: 'Yes, our drivers assist with luggage handling to ensure a smooth and comfortable airport transfer experience.',
  },
  {
    question: 'Are toll and parking charges included in airport fare?',
    answer: 'Toll and parking charges are billed separately as per actuals. Lotus Cab ensures complete pricing transparency before confirming your booking.',
  },
  {
    question: 'Can I book a round trip airport cab from Navi Mumbai?',
    answer: 'Yes, you can book both pickup and return airport transfers in advance with flexible scheduling options.',
  },
  {
    question: 'Is corporate airport transfer available in Navi Mumbai?',
    answer: 'Absolutely. Lotus Cab provides punctual and professional airport transfer services for corporate clients and business travelers.',
  },
  {
    question: 'How can I book Navi Mumbai airport cab with Lotus Cab?',
    answer: 'You can book by sharing your pickup/drop location, flight details, travel date, and vehicle preference to receive instant fare details and booking confirmation.',
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rohan Mehra',
    feedback: 'Booked Lotus Cab for Navi Mumbai airport pickup. The driver tracked our flight and arrived on time. Smooth and hassle-free experience.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Mrs. Pooja Shah',
    feedback: 'Excellent airport cab service in Navi Mumbai. Clean vehicle, polite driver, and transparent pricing. Highly recommended.',
    rating: 5,
  },
];













































































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune Taxi Fare", link: "Pune-Taxi-Fare" },
  { place: "/images/keyword/2.jpg", text: "Pune Outstation Taxi Hire", link: "Pune-Outstation-Taxi-Hire" },
  { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad Online Cab", link: "Pimpri-Chinchwad-Online-Cab" },
  { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
  { place: "/images/keyword/5.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
  { place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "Pune-to-Mahabaleshwar-Cabs" },
  { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab Booking", link: "Pune-to-Lonavala-Cab-Booking" },
  { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cabs", link: "Pune-to-Shirdi-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Pune to Lavasa City Cabs", link: "Pune-to-Lavasa-City-Cabs" },
  { place: "/images/keyword/11.jpg", text: "Pune Airport to Bhimashankar Cabs", link: "Pune-Airport-to-Bhimashankar-Cabs" },
  { place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cabs", link: "Pune-to-Konkan-Darshan-Cabs" },
  { place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
  { place: "/images/keyword/15.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
  { place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab Booking", link: "Pune-to-Panchgani-Cab-Booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Taxi", link: "Pune-to-Mumbai-International-Airport-Taxi" },
  { place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab Package", link: "Ashtavinayak-Darshan-Cab-Package" },
  { place: "/images/keyword/19.jpg", text: "Pune To Nagpur Cabs", link: "Pune-To-Nagpur-Cabs" },
  { place: "/images/keyword/20.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
  { place: "/images/keyword/21.jpg", text: "Taxi Service in Hinjewadi Pune", link: "Taxi-Service-in-Hinjewadi-Pune" },
  { place: "/images/keyword/22.jpg", text: "Pune to Gujarat Cab Service", link: "Pune-to-Gujarat-Cab-Service" },
  { place: "/images/keyword/23.jpg", text: "Travel Agents in Pune", link: "Travel-Agents-in-Pune" },
  { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Bangalore Taxi Service", link: "Pune-to-Bangalore-Taxi-Service" },

];








const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Navi Mumbai Airport Cab",
"image": "https://lotuscab.com/assets/images/navi-mumbai-airport-cab.jpg",
"description": "Book Navi Mumbai Airport Cab with Lotus Cab for safe, reliable, and affordable airport transfers. One way and round trip taxi service with Sedan, SUV, and AC cabs available 24x7 with professional drivers and instant booking confirmation.",
"brand": {
"@type": "Brand",
"name": "Lotus Cab"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "8602"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹12/Km",
"availability": "https://schema.org/InStock",
"url": "https://lotuscab.com/navi-mumbai-airport-cab"
}
};










  return (
    <div>
      

<Helmet>
  <title>Navi Mumbai Airport Cab | 24x7 Airport Pickup & Drop | +91 8767592195</title>

<meta
 name="description"
 content="Book Navi Mumbai Airport Cab with Lotus Cab for affordable airport transfers. 24x7 pickup and drop service with Sedan, SUV, and AC cabs, professional drivers, and instant booking confirmation."
/>

<meta
 name="keywords"
 content="Navi Mumbai Airport Cab, Navi Mumbai Airport Taxi, Airport Cab Navi Mumbai, Navi Mumbai Airport Pickup Cab, Navi Mumbai Airport Drop Cab, Airport Taxi Navi Mumbai, Cheap Airport Cab Navi Mumbai, Best Airport Taxi Navi Mumbai, Online Airport Cab Booking Navi Mumbai, Sedan Airport Cab Navi Mumbai, SUV Airport Cab Navi Mumbai, 24x7 Airport Cab Navi Mumbai, Lotus Cab Navi Mumbai Airport"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>





 <section className="page-header">
      
      {/* Background Image */}
      <div
        className="page-header__bg"
        style={{
          backgroundImage:
            "url(../images/page-header-bg-1-1.jpg)",
        }}
      ></div>
      <div className="container">
        <div className="page-header__content">
        
          <h2 className="page-header__title"> {cardData.keyword}</h2>
        </div>
      </div>
    </section>


      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/84.png' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Lotus Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Lotus Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918767592195" className="pc-call">+91 8767592195</a>
                      <a href="tel:+919172145909" className="pc-call">+91 9172145909</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918767592195"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918767592195" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@lotuscab.com" className="pc-email">
                      booking@lotuscab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Lotus Cab </strong><br />
                    Mauli Krupa building,
                    Sant Tukaram Nagar Gali No.1,
                    Navi sangvi MK chauk -411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Navimumbaiairportcab;